import Vue from 'vue';
import Vuex from 'vuex';
import debounce from 'lodash/debounce';

Vue.use(Vuex);

const store = new Vuex.Store({});

function fetch() {
    store.dispatch('list/fetchIfFiltersChanged');
}

const debounceFetch = debounce(fetch, 1000);

function getFilters(state: any) {
    return state.filters ? state.filters.filters : null;
}

store.watch(
    getFilters,
    filters => {
        if (!filters) {
            return;
        }

        debounceFetch();
    },
    { deep: true }
);

export default store;
